module.exports = __webpack_public_path__ + "img/Embers-Adrift-Brand-Black.3ca4a076.png";